"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetCDNBaseURL = void 0;
var GetCDNBaseURL = exports.GetCDNBaseURL = function GetCDNBaseURL(_ref) {
  var env = _ref.env,
    _ref$defaultBase = _ref.defaultBase,
    defaultBase = _ref$defaultBase === void 0 ? 'https://petcdnstore.blob.core.windows.net/qt-assets' : _ref$defaultBase;
  // TODO: Add urls for other environments
  switch (env) {
    case 'prod':
      return "".concat(defaultBase, "/Prod");
    default:
      return "".concat(defaultBase, "/Non-prod");
  }
};